import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  DatePicker,
  Card,
  Divider,
  Upload,
  Checkbox,
  notification,
  Modal, message
} from "antd";
import {
  BarsOutlined,
  DownloadOutlined,
  MailFilled,
  MailOutlined,
  PlusOutlined,
  UploadOutlined,
  PaperClipOutlined,
  ArrowRightOutlined
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import {
  defaultValidateMessages
} from "../Forms/Helper";
import Iframe from "react-iframe";
import config from "../../util/ApiforContext";
import CustomModal from "../../components/Modal/CustomModal";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};



const Report = ({activeTabKey}) => {
  const [loading, setLoading] = useState(false);

  const containerRef = useRef(null);

  const [sectorSelect, setSectorSelect] = useState({
    data: [],
    loading: false,
  });

  const [isModalVisibleReceipt, setIsModalVisible] = useState(false);
  const [EmailVisible, setEmailVisible] = useState(true);
  const [pdfUrl, setPdfUrl] = useState("");
  const [Email, setEmail] = useState(localStorage.getItem("email"));
  const [pdf, setPdf] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [modalTitle, setModalTitle] = useState("Risk Analiz Raporu");
  const [showCreditModal, setShowCreditModal] = useState(false);

  const [form] = Form.useForm();


  useEffect(() => {

    checkCredit();
  }, [activeTabKey])

  useEffect(() => {
    getSectors();
  }, []);

  const getSectors = () => {
    setSectorSelect({
      ...sectorSelect,
      loading: true,
    });

    RequestHandler.get('/RiskAnalysis/sectors').then((response) => {
      setSectorSelect({
        data: response.data,
        loading: false,
      });
    })
  }

  const clickRules = (event) => {
    event.preventDefault()

    setModalTitle("Yükleme Yapılırken Dikkat Edilmesi Gereken Durumlar");
    setPdfUrl(`${config.apiUrl.replace("/api", "")}/Content/SourcePdf/RiskAnalysisPdf/Yükleme Yapılırken Dikkat Edilmesi Gereken Durumlar.pdf`);
    setIsModalVisible(true);
  }

  const onFinish = (values) => {
    setLoading(true);

    if(values.agreement) {
      const formData = new FormData();

      formData.append("sectorCode", values.sectorCode);
      formData.append("name", values.name);
      formData.append("year", values.date.format("YYYY"));
      formData.append("month", values.date.format("MM"));

      setCompanyName(values.name);

      if (values.file) {
        formData.append("file", values.file.fileList[0].originFileObj);
      }

      RequestHandler.post("/RiskAnalysis/analyze", formData).then((response) => {

        if(response.success) {
          setDocumentNumber(response.data.id);

          RequestHandler.get(`/RiskAnalysis/pdf/${response.data.id}`).then((pdfResponse) => {

            const url = `data:application/pdf;base64,${pdfResponse.base64String}`;
            setPdfUrl(url);
            setPdf(pdfResponse.base64String)

            setIsModalVisible(true);
            setLoading(false);
            checkCredit();
          });
        }
        else {
          setLoading(false);
        }
      })

    }
    else {
      notification.error({
        message: "Kişisel verilerin işlenmesine izin vermeniz gerekmektedir.",
        duration: 3,
      });
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const handleOkReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
    setModalTitle("Risk Analiz Raporu");
    form.resetFields();
  };

  const downloadPdf = () => {
    const hide = message.loading("Pdf indiriliyor...", 0);


    const byteCharacters = atob(pdf); // Base64 decode
    const byteArrays = [];


    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }


    const blob = new Blob(byteArrays, { type: 'application/pdf' });


    const fileName = `${companyName}-Risk Analizi.pdf`;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();



    setIsModalVisible(true);
    hide();
  };

  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };

  const sendMail = () => {
    setLoading(true);
    if (Email.length > 0) {
      RequestHandler.get(
        `/RiskAnalysis/sendEmail/${documentNumber}/${Email}/${companyName}`).then(() => {
        setLoading(false);
      });
    } else {
      notification.error({
        description: "Mail adresi girilmedi.",
        duration: 3,
      });
      setLoading(false);
    }
  };

  const checkCredit = () => {
    RequestHandler.get("/RiskAnalysis/credit-check").then((response) => {
      setShowCreditModal(!response);
    });
  };

  return (
    <>
      <Row justify='center' align='middle'>
        <Col span={24}>
          <Card>
            <Form
              {...formItemLayout}
              validateMessages={defaultValidateMessages}
              form={form}
              name="riskAnalysis"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              labelAlign="left"
              getValueFromEvent={(e) => e?.fileList}
            >
              <Row justify="center">
                <Col span={6}></Col>
                <Col span={12}>


                  <Form.Item name="sectorCode" label="Sektör" rules={[{ required: true }]}>
                    <Select
                      allowClear
                      showSearch
                      placeholder="Seçiniz"
                      filterOption={(input, option) =>
                        option.key.toLocaleLowerCase("tr-TR").indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.name
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={sectorSelect.loading}
                    >
                      {sectorSelect.data.map((item) => (
                        <Select.Option key={item.code} value={item.code} name={item.name}>
                          {item.code} - {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label={
                      "Müşteri bilgisi"
                    }
                    name="name"
                    rules={[{ required: true }]}
                  >
                    <Input  />
                  </Form.Item>

                  <Form.Item label="Beyanname Yılı" name="date" rules={[{ required: true }]}>
                    <DatePicker.YearPicker
                      style={{ width: "100%" }}
                      picker={"year"}
                      format={"YYYY"}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
              </Row>
              <Row justify="center">
                <Col span={24}>
                  <Divider>Ek Bilgiler</Divider>
                </Col>
              </Row>
              <Row justify="center" align="middle">
                <Col span={8}></Col>

                <Col span={8} style={{textAlign: "center"}}>
                  <Form.Item name="file" rules={[
                    {
                      required: true,
                      message: "Beyanname dosyasının yüklenmesi gerekmektedir.",
                    },
                  ]}>
                    <Upload beforeUpload={() => false}
                            className="custom-upload"
                            accept=".pdf"
                            multiple={false}>
                      <Button icon={<UploadOutlined />}  >Belge Yükle</Button>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={8}></Col>
              </Row>
              <Row justify="center">
                <Col span={6}></Col>
                <Col span={12} style={{textAlign:"center"}}>

                  Doğru belge yüklemesi için <a href="#" onClick={clickRules}>dikkat edilmesi gerekenler</a>

                  <br/>
                  <br/>


                  <Form.Item
                    name="agreement"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        message: "Kişisel verilerin işlenmesine izin vermeniz gerekmektedir.",
                      },
                    ]}
                  >


                    <Checkbox>


                      Finansal analiz raporu üretilebilmesi amacıyla şirket unvan, NACE kodu ve kurumlar vergisi beyannamelerimin iş ortaklarına aktarılmasına ve bu kapsamda işlenmesine izin veriyorum.

                      <br/> <br/>

                      Kişisel verilerinizin nasıl işlendiğine dair ayrıntılı bilgiye <a href="https://jetscoring.com/tr/kvkk/aydinlatma"
                                                                                        target="_blank">Aydınlatma
                      Metni</a> üzerinden erişebilirsiniz.
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={6}></Col>

              </Row>
              <Row justify="center">
                <Col span={24} style={{ textAlign: "center" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Rapor Oluştur
                  </Button>
                </Col>
              </Row>

            </Form>
          </Card>
        </Col>
      </Row>

      <Modal
        title={modalTitle}
        width={1000}
        style={{ height: 1000 }}
        visible={isModalVisibleReceipt}
        onOk={handleOkReceipt}
        onCancel={handleOkReceipt}
        footer={null}
      >
        <Form
          name="basic"
          initialValues={{
            remember: true,
          }}
          fields={[{ name: "Email", value: Email }]}
        >
          <Row>
            <Col span={20}></Col>
            <Col span={2}>
              {EmailVisible ? (
                <MailOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              ) : (
                <MailFilled
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              )}
            </Col>
            <Col span={2}>
              <DownloadOutlined
                style={{ fontSize: 20, marginBottom: 20 }}
                onClick={() => downloadPdf()}
              />
            </Col>
          </Row>
          <Row hidden={EmailVisible}>
            <Col span={18}>
              <Form.Item
                label="Mail Adresi"
                name="Email"
                style={{ width: "100%" }}
              >
                <Input value={Email} onChange={onChangeEmail} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => sendMail()}
                  loading={loading}
                >
                  Gönder
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Iframe
          url={pdfUrl}
          width="100%"
          height="1000px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Modal>

      <CustomModal
        visible={showCreditModal}
        title="Üzgünüz, ücretsiz rapor hakkınızı doldurdunuz."
        description="Yeni rapor talebinde bulunmak için <b>F-Ray JetScoring Finansal Analiz Platformu</b> üzerinden talep oluşturabilirsiniz."
        buttonText={ <>JetScoring'e Git {<ArrowRightOutlined style={{ fontSize: '16px' }}  />}</> }
        buttonAction={() => {

          RequestHandler.post("/LinkClickDetail", {
            "SystemName": "Fray"
          }, false);

          window.open(`https://jetscoring.com/tr#demo-request`, '_blank');
        }}

      />


    </>
  );
};


export default Report;
